import React, { FunctionComponent } from 'react';
import { FormikProps } from 'formik';
import { Typography } from '@mui/material';
import InterventionItem from '../InterventionItem/InterventionItem';
import useStyles from './InterventionBody.styles';

interface IProps {
  description?: string | React.ReactElement;
  header?:string;
  subDescription?: string | React.ReactElement;
  fields?: {
    text: string;
    id: string;
    percentage?: boolean;
    showError?: boolean;
    showSlider?: boolean;
    note?: string;
  }[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: FormikProps<any>;
  onNote: (fieldName: string, noteAction: 'add' | 'edit' | 'delete') => void;
}

const InterventionBody: FunctionComponent<IProps> = ({
  description,
  header,
  subDescription,
  fields,
  form,
  onNote
}) => {
  const classes = useStyles();
  return (
    <div>
      {description && (
        <Typography className={classes.description}>{description}</Typography>
      )}
      {header && (
        <Typography variant="h2" className={classes.header}>{header}</Typography>
      )}
      {subDescription && (
        <Typography className={classes.subDescription}>{subDescription}</Typography>
      )}
      {fields?.map((field) => (
        <InterventionItem
          key={field.id}
          field={field}
          form={form}
          onNote={onNote}
        />
      ))}
    </div>
  );
};

export default InterventionBody;
